export const reportTypes: Record<'unassigned' | 'single' | 'weekly', string> = {
  unassigned: '未标注',
  single: '单次报告',
  weekly: '周报',
};

export type ReportType = keyof typeof reportTypes;
